import moment from 'moment';
import React, { Fragment } from 'react';
import { Carousel } from 'react-responsive-carousel';

const NotificationCarousel = ({ data }) => {

    return (
        <div className=''>
            {data != undefined && data.length > 0 ?
                <Carousel showThumbs={false} showArrows={true} renderThumbs={false} showIndicators={false} centerMode={true} showStatus={false}>
                    <div className='flex flex-wrap'>
                        {data.map((notify, index) => {
                            return (
                                <div key={index} className='w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/4 p-2'>
                                    <div className='border rounded p-3 flex flex-col'>
                                        <div className='flex items-center mb-3'>
                                            <img src={notify.title == 'New Guarantor Added' ? '/images/guarantor-added.png' : (notify.title == 'Guarantor removed by Applicant' ? '/images/guarantor-removed.png' : (notify.title == 'Guarantor Rejected' ? '/images/guarantor-rejected.png' : ''))} alt='Icon' className='w-8 h-8 mr-3' />
                                            <div>
                                                <p className='text-sm font-semibold'>{notify.title}</p>
                                                <p className='text-xs text-blue-500'>
                                                    {notify?.guarantor_info?.company_name
                                                        ? notify?.guarantor_info?.company_name.charAt(0).toUpperCase() + notify?.guarantor_info?.company_name.slice(1)
                                                        : notify?.guarantor_info?.name.charAt(0).toUpperCase() +  notify?.guarantor_info?.name.slice(1)}
                                                </p>
                                            </div>
                                        </div>
                                        <div className='mt-auto flex justify-between'>
                                            <div>
                                                <p className='text-[12px] font-[400] text-[#787486]'>{moment(notify.created_at).format("DD MMM YYYY")}</p>
                                            </div>
                                            <div>
                                                <p className='text-[12px] font-[400] text-[#787486]'>{moment(notify.created_at).format("HH:MM")}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>


                </Carousel>
                :
                <div className='text-center mt-3'>No Notifications Available</div>
            }
        </div>
    );
};

export default NotificationCarousel;